module.exports = __webpack_public_path__ + "static/organiktrafikde55buyume-845bf9f3036b151c93cf5d08ceee35a6.jpg";